import _createForOfIteratorHelper from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/webapp/django-projects/art-attack/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isValidElement, useRef, useState, useCallback, useEffect, createContext, useContext, createElement, cloneElement } from 'react';

var isHTMLElement = function isHTMLElement(value) {
  return value instanceof HTMLElement;
};

var EVENTS = {
  BLUR: 'blur',
  CHANGE: 'change',
  INPUT: 'input'
};
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
var VALUE = 'value';
var SELECT = 'select';
var UNDEFINED = 'undefined';
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};

function attachEventListeners(_ref, shouldAttachChangeEvent, handleChange) {
  var ref = _ref.ref;

  if (isHTMLElement(ref) && handleChange) {
    ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
    ref.addEventListener(EVENTS.BLUR, handleChange);
  }
}

var isNullOrUndefined = function isNullOrUndefined(value) {
  return value == null;
};

var isObjectType = function isObjectType(value) {
  return typeof value === 'object';
};

var isObject = function isObject(value) {
  return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);
};

var isKey = function isKey(value) {
  return !Array.isArray(value) && (/^\w*$/.test(value) || !/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/.test(value));
};

var compact = function compact(value) {
  return value.filter(Boolean);
};

var stringToPath = function stringToPath(input) {
  return compact(input.replace(/["|']/g, '').replace(/\[/g, '.').replace(/\]/g, '').split('.'));
};

function set(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;

    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}

var transformToNestObject = function transformToNestObject(data) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  for (var key in data) {
    !isKey(key) ? set(value, key, data[key]) : value[key] = data[key];
  }

  return value;
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

var get = function get(obj, path, defaultValue) {
  var result = compact(path.split(/[,[\].]+?/)).reduce(function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};

var focusOnErrorField = function focusOnErrorField(fields, fieldErrors) {
  for (var key in fields) {
    if (get(fieldErrors, key)) {
      var field = fields[key];

      if (field) {
        if (field.ref.focus) {
          field.ref.focus();
          break;
        } else if (field.options) {
          field.options[0].ref.focus();
          break;
        }
      }
    }
  }
};

var removeAllEventListeners = function removeAllEventListeners(ref, validateWithStateUpdate) {
  if (isHTMLElement(ref) && ref.removeEventListener) {
    ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
    ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
  }
};

var defaultReturn = {
  isValid: false,
  value: ''
};

var getRadioValue = function getRadioValue(options) {
  return Array.isArray(options) ? options.reduce(function (previous, option) {
    return option && option.ref.checked ? {
      isValid: true,
      value: option.ref.value
    } : previous;
  }, defaultReturn) : defaultReturn;
};

var getMultipleSelectValue = function getMultipleSelectValue(options) {
  return _toConsumableArray(options).filter(function (_ref2) {
    var selected = _ref2.selected;
    return selected;
  }).map(function (_ref3) {
    var value = _ref3.value;
    return value;
  });
};

var isRadioInput = function isRadioInput(element) {
  return element.type === 'radio';
};

var isFileInput = function isFileInput(element) {
  return element.type === 'file';
};

var isCheckBoxInput = function isCheckBoxInput(element) {
  return element.type === 'checkbox';
};

var isMultipleSelect = function isMultipleSelect(element) {
  return element.type === "".concat(SELECT, "-multiple");
};

var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};

var getCheckboxValue = function getCheckboxValue(options) {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      var values = options.filter(function (option) {
        return option && option.ref.checked;
      }).map(function (_ref4) {
        var value = _ref4.ref.value;
        return value;
      });
      return {
        value: values,
        isValid: !!values.length
      };
    }

    var _options$0$ref = options[0].ref,
        checked = _options$0$ref.checked,
        value = _options$0$ref.value,
        attributes = _options$0$ref.attributes;
    return checked ? attributes && !isUndefined(attributes.value) ? isUndefined(value) || value === '' ? validResult : {
      value: value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
};

function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled) {
  var field = fieldsRef.current[name];

  if (field) {
    var _field$ref = field.ref,
        value = _field$ref.value,
        disabled = _field$ref.disabled,
        ref = field.ref;

    if (disabled && excludeDisabled) {
      return;
    }

    if (isFileInput(ref)) {
      return ref.files;
    }

    if (isRadioInput(ref)) {
      return getRadioValue(field.options).value;
    }

    if (isMultipleSelect(ref)) {
      return getMultipleSelectValue(ref.options);
    }

    if (isCheckBoxInput(ref)) {
      return getCheckboxValue(field.options).value;
    }

    return value;
  }

  if (shallowFieldsStateRef) {
    return get(shallowFieldsStateRef.current, name);
  }
}

function isDetached(element) {
  if (!element) {
    return true;
  }

  if (!(element instanceof HTMLElement) || element.nodeType === Node.DOCUMENT_NODE) {
    return false;
  }

  return isDetached(element.parentNode);
}

var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && !Object.keys(value).length;
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

function baseGet(object, updatePath) {
  var path = updatePath.slice(0, -1);
  var length = path.length;
  var index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return object;
}

function unset(object, path) {
  var updatePath = isKey(path) ? [path] : stringToPath(path);
  var childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
  var key = updatePath[updatePath.length - 1];
  var previousObjRef = undefined;

  if (childObject) {
    delete childObject[key];
  }

  for (var k = 0; k < updatePath.slice(0, -1).length; k++) {
    var index = -1;
    var objectRef = undefined;
    var currentPaths = updatePath.slice(0, -(k + 1));
    var currentPathsLength = currentPaths.length - 1;

    if (k > 0) {
      previousObjRef = object;
    }

    while (++index < currentPaths.length) {
      var item = currentPaths[index];
      objectRef = objectRef ? objectRef[item] : object[item];

      if (currentPathsLength === index && (isObject(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter(function (data) {
        return isObject(data) && !isEmptyObject(data) || isBoolean(data);
      }).length)) {
        previousObjRef ? delete previousObjRef[item] : delete object[item];
      }

      previousObjRef = objectRef;
    }
  }

  return object;
}

var isSameRef = function isSameRef(fieldValue, ref) {
  return fieldValue && fieldValue.ref === ref;
};

function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
  var ref = field.ref,
      _field$ref2 = field.ref,
      name = _field$ref2.name,
      type = _field$ref2.type;
  var fieldRef = fieldsRef.current[name];

  if (!shouldUnregister) {
    var value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);

    if (!isUndefined(value)) {
      set(shallowFieldsStateRef.current, name, value);
    }
  }

  if (!type) {
    delete fieldsRef.current[name];
    return;
  }

  if ((isRadioInput(ref) || isCheckBoxInput(ref)) && fieldRef) {
    var options = fieldRef.options;

    if (Array.isArray(options) && options.length) {
      compact(options).forEach(function (option, index) {
        var ref = option.ref;

        if (ref && isDetached(ref) && isSameRef(option, ref) || forceDelete) {
          removeAllEventListeners(ref, handleChange);
          unset(options, "[".concat(index, "]"));
        }
      });

      if (options && !compact(options).length) {
        delete fieldsRef.current[name];
      }
    } else {
      delete fieldsRef.current[name];
    }
  } else if (isDetached(ref) && isSameRef(fieldRef, ref) || forceDelete) {
    removeAllEventListeners(ref, handleChange);
    delete fieldsRef.current[name];
  }
}

function setFieldArrayDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
  var index = -1;

  while (++index < values.length) {
    for (var key in values[index]) {
      if (Array.isArray(values[index][key])) {
        !dirtyFields[index] && (dirtyFields[index] = {});
        dirtyFields[index][key] = [];
        setFieldArrayDirtyFields(values[index][key], get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
      } else {
        get(defaultValues[index] || {}, key) === values[index][key] ? set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), {
          [key]: true
        });
      }
    }

    !dirtyFields.length && parentNode && delete parentNode[parentName];
  }

  return dirtyFields.length ? dirtyFields : undefined;
}

var isString = function isString(value) {
  return typeof value === 'string';
};

var isPrimitive = function isPrimitive(value) {
  return isNullOrUndefined(value) || !isObjectType(value);
};

function deepMerge(target, source) {
  if (isPrimitive(target) || isPrimitive(source)) {
    return source;
  }

  for (var key in source) {
    var targetValue = target[key];
    var sourceValue = source[key];

    try {
      target[key] = isObject(targetValue) && isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
    } catch (_a) {}
  }

  return target;
}

var getFieldsValues = function getFieldsValues(fieldsRef, shallowFieldsStateRef, excludeDisabled, search) {
  var output = {};

  var _loop = function _loop(name) {
    if (isUndefined(search) || (isString(search) ? name.startsWith(search) : Array.isArray(search) && search.find(function (data) {
      return name.startsWith(data);
    }))) {
      output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
    }
  };

  for (var name in fieldsRef.current) {
    _loop(name);
  }

  return deepMerge(transformToNestObject(Object.assign({}, (shallowFieldsStateRef || {}).current || {})), transformToNestObject(output));
};

function deepEqual() {
  var object1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var object2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isErrorObject = arguments.length > 2 ? arguments[2] : undefined;
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];

    if (!(isErrorObject && ['ref', 'context'].includes(key))) {
      var val1 = object1[key];
      var val2 = object2[key];

      if ((isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
        return false;
      }
    }
  }

  return true;
}

function isErrorStateChanged(_ref5) {
  var errors = _ref5.errors,
      name = _ref5.name,
      error = _ref5.error,
      validFields = _ref5.validFields,
      fieldsWithValidation = _ref5.fieldsWithValidation;
  var isValid = isUndefined(error);
  var previousError = get(errors, name);
  return isValid && !!previousError || !isValid && !deepEqual(previousError, error, true) || isValid && get(fieldsWithValidation, name) && !get(validFields, name);
}

var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};

var isValueMessage = function isValueMessage(value) {
  return isObject(value) && !isRegex(value);
};

var getValueAndMessage = function getValueAndMessage(validationData) {
  return isValueMessage(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isMessage = function isMessage(value) {
  return isString(value) || isObject(value) && isValidElement(value);
};

function getValidateError(result, ref) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

  if (isMessage(result) || isBoolean(result) && !result) {
    return {
      type,
      message: isMessage(result) ? result : '',
      ref
    };
  }
}

var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
  if (validateAllFieldCriteria) {
    var error = errors[name];
    return Object.assign(Object.assign({}, error), {
      types: Object.assign(Object.assign({}, error && error.types ? error.types : {}), {
        [type]: message || true
      })
    });
  }

  return {};
};

var validateField = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldsRef, validateAllFieldCriteria, _ref6, shallowFieldsStateRef) {
    var ref, _ref6$ref, type, value, options, required, maxLength, minLength, min, max, pattern, validate, fields, name, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref8, requiredValue, requiredMessage, exceedMax, exceedMin, _getValueAndMessage, maxValue, maxMessage, _getValueAndMessage2, minValue, minMessage, valueNumber, valueDate, _getValueAndMessage3, maxLengthValue, maxLengthMessage, _getValueAndMessage4, minLengthValue, minLengthMessage, inputLength, _exceedMax, _exceedMin, _getValueAndMessage5, patternValue, patternMessage, fieldValue, validateRef, result, validateError, validationResult, _i2, _Object$entries, _Object$entries$_i, key, validateFunction, validateResult, _validateError;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ref = _ref6.ref, _ref6$ref = _ref6.ref, type = _ref6$ref.type, value = _ref6$ref.value, options = _ref6.options, required = _ref6.required, maxLength = _ref6.maxLength, minLength = _ref6.minLength, min = _ref6.min, max = _ref6.max, pattern = _ref6.pattern, validate = _ref6.validate;
            fields = fieldsRef.current;
            name = ref.name;
            error = {};
            isRadio = isRadioInput(ref);
            isCheckBox = isCheckBoxInput(ref);
            isRadioOrCheckbox = isRadio || isCheckBox;
            isEmpty = value === '';
            appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

            getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
              var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
              var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
              var message = exceedMax ? maxLengthMessage : minLengthMessage;
              error[name] = Object.assign({
                type: exceedMax ? maxType : minType,
                message,
                ref
              }, exceedMax ? appendErrorsCurry(maxType, message) : appendErrorsCurry(minType, message));
            };

            if (!(required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value)) || isBoolean(value) && !value || isCheckBox && !getCheckboxValue(options).isValid || isRadio && !getRadioValue(options).isValid))) {
              _context.next = 16;
              break;
            }

            _ref8 = isMessage(required) ? {
              value: !!required,
              message: required
            } : getValueAndMessage(required), requiredValue = _ref8.value, requiredMessage = _ref8.message;

            if (!requiredValue) {
              _context.next = 16;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.required,
              message: requiredMessage,
              ref: isRadioOrCheckbox ? ((fields[name].options || [])[0] || {}).ref : ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, requiredMessage));

            if (validateAllFieldCriteria) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", error);

          case 16:
            if (!(!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
              _context.next = 24;
              break;
            }

            _getValueAndMessage = getValueAndMessage(max), maxValue = _getValueAndMessage.value, maxMessage = _getValueAndMessage.message;
            _getValueAndMessage2 = getValueAndMessage(min), minValue = _getValueAndMessage2.value, minMessage = _getValueAndMessage2.message;

            if (type === 'number' || !type && !isNaN(value)) {
              valueNumber = ref.valueAsNumber || parseFloat(value);

              if (!isNullOrUndefined(maxValue)) {
                exceedMax = valueNumber > maxValue;
              }

              if (!isNullOrUndefined(minValue)) {
                exceedMin = valueNumber < minValue;
              }
            } else {
              valueDate = ref.valueAsDate || new Date(value);

              if (isString(maxValue)) {
                exceedMax = valueDate > new Date(maxValue);
              }

              if (isString(minValue)) {
                exceedMin = valueDate < new Date(minValue);
              }
            }

            if (!(exceedMax || exceedMin)) {
              _context.next = 24;
              break;
            }

            getMinMaxMessage(!!exceedMax, maxMessage, minMessage, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

            if (validateAllFieldCriteria) {
              _context.next = 24;
              break;
            }

            return _context.abrupt("return", error);

          case 24:
            if (!(isString(value) && !isEmpty && (maxLength || minLength))) {
              _context.next = 34;
              break;
            }

            _getValueAndMessage3 = getValueAndMessage(maxLength), maxLengthValue = _getValueAndMessage3.value, maxLengthMessage = _getValueAndMessage3.message;
            _getValueAndMessage4 = getValueAndMessage(minLength), minLengthValue = _getValueAndMessage4.value, minLengthMessage = _getValueAndMessage4.message;
            inputLength = value.toString().length;
            _exceedMax = !isNullOrUndefined(maxLengthValue) && inputLength > maxLengthValue;
            _exceedMin = !isNullOrUndefined(minLengthValue) && inputLength < minLengthValue;

            if (!(_exceedMax || _exceedMin)) {
              _context.next = 34;
              break;
            }

            getMinMaxMessage(!!_exceedMax, maxLengthMessage, minLengthMessage);

            if (validateAllFieldCriteria) {
              _context.next = 34;
              break;
            }

            return _context.abrupt("return", error);

          case 34:
            if (!(pattern && !isEmpty)) {
              _context.next = 40;
              break;
            }

            _getValueAndMessage5 = getValueAndMessage(pattern), patternValue = _getValueAndMessage5.value, patternMessage = _getValueAndMessage5.message;

            if (!(isRegex(patternValue) && !patternValue.test(value))) {
              _context.next = 40;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.pattern,
              message: patternMessage,
              ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, patternMessage));

            if (validateAllFieldCriteria) {
              _context.next = 40;
              break;
            }

            return _context.abrupt("return", error);

          case 40:
            if (!validate) {
              _context.next = 73;
              break;
            }

            fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
            validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;

            if (!isFunction(validate)) {
              _context.next = 54;
              break;
            }

            _context.next = 46;
            return validate(fieldValue);

          case 46:
            result = _context.sent;
            validateError = getValidateError(result, validateRef);

            if (!validateError) {
              _context.next = 52;
              break;
            }

            error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

            if (validateAllFieldCriteria) {
              _context.next = 52;
              break;
            }

            return _context.abrupt("return", error);

          case 52:
            _context.next = 73;
            break;

          case 54:
            if (!isObject(validate)) {
              _context.next = 73;
              break;
            }

            validationResult = {};
            _i2 = 0, _Object$entries = Object.entries(validate);

          case 57:
            if (!(_i2 < _Object$entries.length)) {
              _context.next = 69;
              break;
            }

            _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), key = _Object$entries$_i[0], validateFunction = _Object$entries$_i[1];

            if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
              _context.next = 61;
              break;
            }

            return _context.abrupt("break", 69);

          case 61:
            _context.next = 63;
            return validateFunction(fieldValue);

          case 63:
            validateResult = _context.sent;
            _validateError = getValidateError(validateResult, validateRef, key);

            if (_validateError) {
              validationResult = Object.assign(Object.assign({}, _validateError), appendErrorsCurry(key, _validateError.message));

              if (validateAllFieldCriteria) {
                error[name] = validationResult;
              }
            }

          case 66:
            _i2++;
            _context.next = 57;
            break;

          case 69:
            if (isEmptyObject(validationResult)) {
              _context.next = 73;
              break;
            }

            error[name] = Object.assign({
              ref: validateRef
            }, validationResult);

            if (validateAllFieldCriteria) {
              _context.next = 73;
              break;
            }

            return _context.abrupt("return", error);

          case 73:
            return _context.abrupt("return", error);

          case 74:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateField(_x, _x2, _x3, _x4) {
    return _ref7.apply(this, arguments);
  };
}();

var getPath = function getPath(path, values) {
  var getInnerPath = function getInnerPath(key, value, isObject) {
    var pathWithIndex = isObject ? "".concat(path, ".").concat(key) : "".concat(path, "[").concat(key, "]");
    return isPrimitive(value) ? pathWithIndex : getPath(pathWithIndex, value);
  };

  return Object.entries(values).map(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        key = _ref10[0],
        value = _ref10[1];

    return getInnerPath(key, value, isObject(values));
  }).flat(Infinity);
};

var assignWatchFields = function assignWatchFields(fieldValues, fieldName, watchFields, inputValue, isSingleField) {
  var value;
  watchFields.add(fieldName);

  if (isEmptyObject(fieldValues)) {
    value = undefined;
  } else {
    value = get(fieldValues, fieldName);

    if (isObject(value) || Array.isArray(value)) {
      getPath(fieldName, value).forEach(function (name) {
        return watchFields.add(name);
      });
    }
  }

  return isUndefined(value) ? isSingleField ? inputValue : get(inputValue, fieldName) : value;
};

var skipValidation = function skipValidation(_ref11) {
  var isOnBlur = _ref11.isOnBlur,
      isOnChange = _ref11.isOnChange,
      isOnTouch = _ref11.isOnTouch,
      isTouched = _ref11.isTouched,
      isReValidateOnBlur = _ref11.isReValidateOnBlur,
      isReValidateOnChange = _ref11.isReValidateOnChange,
      isBlurEvent = _ref11.isBlurEvent,
      isSubmitted = _ref11.isSubmitted,
      isOnAll = _ref11.isOnAll;

  if (isOnAll) {
    return false;
  } else if (!isSubmitted && isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
    return isBlurEvent;
  }

  return true;
};

var getFieldArrayParentName = function getFieldArrayParentName(name) {
  return name.substring(0, name.indexOf('['));
};

var isMatchFieldArrayName = function isMatchFieldArrayName(name, searchName) {
  return RegExp("^".concat(searchName, "[\\d+]").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
};

var isNameInFieldArray = function isNameInFieldArray(names, name) {
  return _toConsumableArray(names).some(function (current) {
    return isMatchFieldArrayName(name, current);
  });
};

var isSelectInput = function isSelectInput(element) {
  return element.type === "".concat(SELECT, "-one");
};

function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
  var observer = new MutationObserver(function () {
    for (var _i3 = 0, _Object$values = Object.values(fieldsRef.current); _i3 < _Object$values.length; _i3++) {
      var field = _Object$values[_i3];

      if (field && field.options) {
        var _iterator = _createForOfIteratorHelper(field.options),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var option = _step.value;

            if (option && option.ref && isDetached(option.ref)) {
              removeFieldEventListenerAndRef(field);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (field && isDetached(field.ref)) {
        removeFieldEventListenerAndRef(field);
      }
    }
  });
  observer.observe(window.document, {
    childList: true,
    subtree: true
  });
  return observer;
}

function cloneObject(data, isWeb) {
  var copy;

  if (isPrimitive(data) || isWeb && data instanceof File) {
    return data;
  }

  if (data instanceof Date) {
    copy = new Date(data.getTime());
    return copy;
  }

  if (data instanceof Set) {
    copy = new Set();

    var _iterator2 = _createForOfIteratorHelper(data),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        copy.add(item);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return copy;
  }

  if (data instanceof Map) {
    copy = new Map();

    var _iterator3 = _createForOfIteratorHelper(data.keys()),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var key = _step3.value;
        copy.set(key, cloneObject(data.get(key), isWeb));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return copy;
  }

  copy = Array.isArray(data) ? [] : {};

  for (var _key in data) {
    copy[_key] = cloneObject(data[_key], isWeb);
  }

  return copy;
}

var modeChecker = function modeChecker(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched
  };
};

var isRadioOrCheckboxFunction = function isRadioOrCheckboxFunction(ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
};

var isWindowUndefined = typeof window === UNDEFINED;
var isWeb = typeof document !== UNDEFINED && !isWindowUndefined && !isUndefined(window.HTMLElement);
var isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;

function useForm() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref12$mode = _ref12.mode,
      mode = _ref12$mode === void 0 ? VALIDATION_MODE.onSubmit : _ref12$mode,
      _ref12$reValidateMode = _ref12.reValidateMode,
      reValidateMode = _ref12$reValidateMode === void 0 ? VALIDATION_MODE.onChange : _ref12$reValidateMode,
      resolver = _ref12.resolver,
      context = _ref12.context,
      _ref12$defaultValues = _ref12.defaultValues,
      defaultValues = _ref12$defaultValues === void 0 ? {} : _ref12$defaultValues,
      _ref12$shouldFocusErr = _ref12.shouldFocusError,
      shouldFocusError = _ref12$shouldFocusErr === void 0 ? true : _ref12$shouldFocusErr,
      _ref12$shouldUnregist = _ref12.shouldUnregister,
      shouldUnregister = _ref12$shouldUnregist === void 0 ? true : _ref12$shouldUnregist,
      criteriaMode = _ref12.criteriaMode;

  var fieldsRef = useRef({});
  var fieldArrayDefaultValuesRef = useRef({});
  var watchFieldsRef = useRef(new Set());
  var useWatchFieldsRef = useRef({});
  var useWatchRenderFunctionsRef = useRef({});
  var fieldsWithValidationRef = useRef({});
  var validFieldsRef = useRef({});
  var defaultValuesRef = useRef(defaultValues);
  var defaultValuesAtRenderRef = useRef({});
  var isUnMount = useRef(false);
  var isWatchAllRef = useRef(false);
  var handleChangeRef = useRef();
  var shallowFieldsStateRef = useRef(shouldUnregister ? {} : cloneObject(defaultValues, isWeb));
  var resetFieldArrayFunctionRef = useRef({});
  var contextRef = useRef(context);
  var resolverRef = useRef(resolver);
  var fieldArrayNamesRef = useRef(new Set());
  var modeRef = useRef(modeChecker(mode));
  var _modeRef$current = modeRef.current,
      isOnSubmit = _modeRef$current.isOnSubmit,
      isOnTouch = _modeRef$current.isOnTouch;
  var isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;

  var _useState = useState({
    isDirty: false,
    dirtyFields: {},
    isSubmitted: false,
    submitCount: 0,
    touched: {},
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: !isOnSubmit,
    errors: {}
  }),
      _useState2 = _slicedToArray(_useState, 2),
      formState = _useState2[0],
      setFormState = _useState2[1];

  var readFormStateRef = useRef({
    isDirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    touched: !isProxyEnabled || isOnTouch,
    isSubmitting: !isProxyEnabled,
    isValid: !isProxyEnabled
  });
  var formStateRef = useRef(formState);
  var observerRef = useRef();
  var _useRef$current = useRef(modeChecker(reValidateMode)).current,
      isReValidateOnBlur = _useRef$current.isOnBlur,
      isReValidateOnChange = _useRef$current.isOnChange;
  contextRef.current = context;
  resolverRef.current = resolver;
  formStateRef.current = formState;
  var updateFormState = useCallback(function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return !isUnMount.current && setFormState(Object.assign(Object.assign({}, formStateRef.current), state));
  }, []);
  var shouldRenderBaseOnError = useCallback(function (name, error) {
    var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var isValid = arguments.length > 4 ? arguments[4] : undefined;
    var shouldReRender = shouldRender || isErrorStateChanged({
      errors: formStateRef.current.errors,
      error,
      name,
      validFields: validFieldsRef.current,
      fieldsWithValidation: fieldsWithValidationRef.current
    });
    var previousError = get(formStateRef.current.errors, name);

    if (error) {
      unset(validFieldsRef.current, name);
      shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error, true);
      set(formStateRef.current.errors, name, error);
    } else {
      if (get(fieldsWithValidationRef.current, name) || resolverRef.current) {
        set(validFieldsRef.current, name, true);
        shouldReRender = shouldReRender || previousError;
      }

      unset(formStateRef.current.errors, name);
    }

    if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state)) {
      updateFormState(Object.assign(Object.assign(Object.assign({}, state), {
        errors: formStateRef.current.errors
      }), resolverRef.current ? {
        isValid: !!isValid
      } : {}));
    }
  }, []);
  var setFieldValue = useCallback(function (name, rawValue) {
    var _fieldsRef$current$na = fieldsRef.current[name],
        ref = _fieldsRef$current$na.ref,
        options = _fieldsRef$current$na.options;
    var value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue) ? '' : rawValue;

    if (isRadioInput(ref) && options) {
      options.forEach(function (_ref13) {
        var radioRef = _ref13.ref;
        return radioRef.checked = radioRef.value === value;
      });
    } else if (isFileInput(ref) && !isString(value)) {
      ref.files = value;
    } else if (isMultipleSelect(ref)) {
      _toConsumableArray(ref.options).forEach(function (selectRef) {
        return selectRef.selected = value.includes(selectRef.value);
      });
    } else if (isCheckBoxInput(ref) && options) {
      options.length > 1 ? options.forEach(function (_ref14) {
        var checkboxRef = _ref14.ref;
        return checkboxRef.checked = Array.isArray(value) ? !!value.find(function (data) {
          return data === checkboxRef.value;
        }) : value === checkboxRef.value;
      }) : options[0].ref.checked = !!value;
    } else {
      ref.value = value;
    }
  }, []);

  var isFormDirty = function isFormDirty() {
    return !deepEqual(getValues(), isEmptyObject(defaultValuesRef.current) ? defaultValuesAtRenderRef.current : defaultValuesRef.current) || !isEmptyObject(formStateRef.current.dirtyFields);
  };

  var updateAndGetDirtyState = useCallback(function (name) {
    var shouldRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
      var isFieldDirty = get(defaultValuesAtRenderRef.current, name) !== getFieldValue(fieldsRef, name, shallowFieldsStateRef);
      var isDirtyFieldExist = get(formStateRef.current.dirtyFields, name);
      var previousIsDirty = formStateRef.current.isDirty;
      isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
      var state = {
        isDirty: isFormDirty(),
        dirtyFields: formStateRef.current.dirtyFields
      };
      var isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== get(formStateRef.current.dirtyFields, name);

      if (isChanged && shouldRender) {
        formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
        updateFormState(Object.assign({}, state));
      }

      return isChanged ? state : {};
    }

    return {};
  }, []);
  var executeValidation = useCallback( /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, skipReRender) {
      var _error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!fieldsRef.current[name]) {
                _context2.next = 7;
                break;
              }

              _context2.next = 3;
              return validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef);

            case 3:
              _context2.t0 = name;
              _error = _context2.sent[_context2.t0];
              shouldRenderBaseOnError(name, _error, skipReRender);
              return _context2.abrupt("return", isUndefined(_error));

            case 7:
              return _context2.abrupt("return", false);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x5, _x6) {
      return _ref15.apply(this, arguments);
    };
  }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  var executeSchemaOrResolverValidation = useCallback( /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(names) {
      var _yield$resolverRef$cu, errors, previousFormIsValid, isInputsValid, _error2;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

            case 2:
              _yield$resolverRef$cu = _context3.sent;
              errors = _yield$resolverRef$cu.errors;
              previousFormIsValid = formStateRef.current.isValid;

              if (!Array.isArray(names)) {
                _context3.next = 11;
                break;
              }

              isInputsValid = names.map(function (name) {
                var error = get(errors, name);
                error ? set(formStateRef.current.errors, name, error) : unset(formStateRef.current.errors, name);
                return !error;
              }).every(Boolean);
              updateFormState({
                isValid: isEmptyObject(errors),
                errors: formStateRef.current.errors
              });
              return _context3.abrupt("return", isInputsValid);

            case 11:
              _error2 = get(errors, names);
              shouldRenderBaseOnError(names, _error2, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
              return _context3.abrupt("return", !_error2);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x7) {
      return _ref16.apply(this, arguments);
    };
  }(), [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
  var trigger = useCallback( /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
      var fields, result;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              fields = name || Object.keys(fieldsRef.current);

              if (!resolverRef.current) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", executeSchemaOrResolverValidation(fields));

            case 3:
              if (!Array.isArray(fields)) {
                _context5.next = 9;
                break;
              }

              _context5.next = 6;
              return Promise.all(fields.map( /*#__PURE__*/function () {
                var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return executeValidation(data, null);

                        case 2:
                          return _context4.abrupt("return", _context4.sent);

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x9) {
                  return _ref18.apply(this, arguments);
                };
              }()));

            case 6:
              result = _context5.sent;
              updateFormState();
              return _context5.abrupt("return", result.every(Boolean));

            case 9:
              _context5.next = 11;
              return executeValidation(fields, readFormStateRef.current.isValid);

            case 11:
              return _context5.abrupt("return", _context5.sent);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x8) {
      return _ref17.apply(this, arguments);
    };
  }(), [executeSchemaOrResolverValidation, executeValidation]);
  var setInternalValues = useCallback(function (name, value, _ref19) {
    var shouldDirty = _ref19.shouldDirty,
        shouldValidate = _ref19.shouldValidate;
    var data = {};
    set(data, name, value);

    var _iterator4 = _createForOfIteratorHelper(getPath(name, value)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var fieldName = _step4.value;

        if (fieldsRef.current[fieldName]) {
          setFieldValue(fieldName, get(data, fieldName));
          shouldDirty && updateAndGetDirtyState(fieldName);
          shouldValidate && trigger(fieldName);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }, [trigger, setFieldValue, updateAndGetDirtyState]);
  var setInternalValue = useCallback(function (name, value) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (fieldsRef.current[name]) {
      setFieldValue(name, value);
      config.shouldDirty && updateAndGetDirtyState(name);
    } else if (!isPrimitive(value)) {
      setInternalValues(name, value, config);

      if (fieldArrayNamesRef.current.has(name)) {
        fieldArrayDefaultValuesRef.current[name] = value;
        resetFieldArrayFunctionRef.current[name]({
          [name]: value
        });

        if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && config.shouldDirty) {
          set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
          updateFormState({
            isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), {
              [name]: value
            }), defaultValuesRef.current),
            dirtyFields: formStateRef.current.dirtyFields
          });
        }
      }
    }

    !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
  }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);

  var isFieldWatched = function isFieldWatched(name) {
    return isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
  };

  var renderWatchedInputs = function renderWatchedInputs(name) {
    var found = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (!isEmptyObject(useWatchFieldsRef.current)) {
      for (var key in useWatchFieldsRef.current) {
        if (!name || !useWatchFieldsRef.current[key].size || useWatchFieldsRef.current[key].has(name) || useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
          useWatchRenderFunctionsRef.current[key]();
          found = false;
        }
      }
    }

    return found;
  };

  function setValue(name, value, config) {
    setInternalValue(name, value, config);
    isFieldWatched(name) && updateFormState();
    renderWatchedInputs(name);
    (config || {}).shouldValidate && trigger(name);
  }

  handleChangeRef.current = handleChangeRef.current ? handleChangeRef.current : /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref20) {
      var type, target, name, field, error, isValid, isBlurEvent, shouldSkipValidation, state, shouldRender, _yield$resolverRef$cu2, errors, previousFormIsValid;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              type = _ref20.type, target = _ref20.target;
              name = target.name;
              field = fieldsRef.current[name];

              if (!field) {
                _context6.next = 29;
                break;
              }

              isBlurEvent = type === EVENTS.BLUR;
              shouldSkipValidation = skipValidation(Object.assign({
                isBlurEvent,
                isReValidateOnChange,
                isReValidateOnBlur,
                isTouched: !!get(formStateRef.current.touched, name),
                isSubmitted: formStateRef.current.isSubmitted
              }, modeRef.current));
              state = updateAndGetDirtyState(name, false);
              shouldRender = !isEmptyObject(state) || isFieldWatched(name);

              if (isBlurEvent && !get(formStateRef.current.touched, name) && readFormStateRef.current.touched) {
                set(formStateRef.current.touched, name, true);
                state = Object.assign(Object.assign({}, state), {
                  touched: formStateRef.current.touched
                });
              }

              if (!shouldSkipValidation) {
                _context6.next = 12;
                break;
              }

              renderWatchedInputs(name);
              return _context6.abrupt("return", (!isEmptyObject(state) || shouldRender && isEmptyObject(state)) && updateFormState(state));

            case 12:
              if (!resolverRef.current) {
                _context6.next = 23;
                break;
              }

              _context6.next = 15;
              return resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);

            case 15:
              _yield$resolverRef$cu2 = _context6.sent;
              errors = _yield$resolverRef$cu2.errors;
              previousFormIsValid = formStateRef.current.isValid;
              error = get(errors, name);
              isValid = isEmptyObject(errors);

              if (previousFormIsValid !== isValid) {
                shouldRender = true;
              }

              _context6.next = 27;
              break;

            case 23:
              _context6.next = 25;
              return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

            case 25:
              _context6.t0 = name;
              error = _context6.sent[_context6.t0];

            case 27:
              renderWatchedInputs(name);
              shouldRenderBaseOnError(name, error, shouldRender, state, isValid);

            case 29:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x10) {
      return _ref21.apply(this, arguments);
    };
  }();

  function setFieldArrayDefaultValues(data) {
    if (!shouldUnregister) {
      var copy = cloneObject(data, isWeb);

      var _iterator5 = _createForOfIteratorHelper(fieldArrayNamesRef.current),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var value = _step5.value;

          if (isKey(value) && !copy[value]) {
            copy = Object.assign(Object.assign({}, copy), {
              [value]: []
            });
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return copy;
    }

    return data;
  }

  function getValues(payload) {
    if (isString(payload)) {
      return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
    }

    if (Array.isArray(payload)) {
      var data = {};

      var _iterator6 = _createForOfIteratorHelper(payload),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _name = _step6.value;
          set(data, _name, getFieldValue(fieldsRef, _name, shallowFieldsStateRef));
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return data;
    }

    return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, shallowFieldsStateRef));
  }

  var validateResolver = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var values,
        _yield$resolverRef$cu3,
        errors,
        isValid,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            values = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
            _context7.next = 3;
            return resolverRef.current(Object.assign(Object.assign(Object.assign({}, defaultValuesRef.current), getValues()), values), contextRef.current, isValidateAllFieldCriteria);

          case 3:
            _yield$resolverRef$cu3 = _context7.sent;
            errors = _yield$resolverRef$cu3.errors;
            isValid = isEmptyObject(errors);
            formStateRef.current.isValid !== isValid && updateFormState({
              isValid
            });

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [isValidateAllFieldCriteria]);
  var removeFieldEventListener = useCallback(function (field, forceDelete) {
    return findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);
  }, [shouldUnregister]);

  var updateWatchedValue = function updateWatchedValue(name) {
    if (isWatchAllRef.current) {
      updateFormState();
    } else if (watchFieldsRef) {
      var shouldRenderUseWatch = true;

      var _iterator7 = _createForOfIteratorHelper(watchFieldsRef.current),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var watchField = _step7.value;

          if (watchField.startsWith(name)) {
            updateFormState();
            shouldRenderUseWatch = false;
            break;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      shouldRenderUseWatch && renderWatchedInputs(name);
    }
  };

  var removeFieldEventListenerAndRef = useCallback(function (field, forceDelete) {
    if (field) {
      removeFieldEventListener(field, forceDelete);

      if (shouldUnregister && !compact(field.options || []).length) {
        unset(defaultValuesAtRenderRef.current, field.ref.name);
        unset(validFieldsRef.current, field.ref.name);
        unset(fieldsWithValidationRef.current, field.ref.name);
        unset(formStateRef.current.errors, field.ref.name);
        set(formStateRef.current.dirtyFields, field.ref.name, true);
        updateFormState({
          errors: formStateRef.current.errors,
          isDirty: isFormDirty(),
          dirtyFields: formStateRef.current.dirtyFields
        });
        readFormStateRef.current.isValid && resolverRef.current && validateResolver();
        updateWatchedValue(field.ref.name);
      }
    }
  }, [validateResolver, removeFieldEventListener]);

  function clearErrors(name) {
    name && (Array.isArray(name) ? name : [name]).forEach(function (inputName) {
      return fieldsRef.current[inputName] ? isKey(inputName) ? delete formStateRef.current.errors[inputName] : set(formStateRef.current.errors, inputName, undefined) : unset(formStateRef.current.errors, inputName);
    });
    updateFormState({
      errors: name ? formStateRef.current.errors : {}
    });
  }

  function setError(name, error) {
    var ref = (fieldsRef.current[name] || {}).ref;
    set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
      ref
    }));
    updateFormState({
      isValid: false,
      errors: formStateRef.current.errors
    });
    error.shouldFocus && ref && ref.focus && ref.focus();
  }

  var watchInternal = useCallback(function (fieldNames, defaultValue, watchId) {
    var watchFields = watchId ? useWatchFieldsRef.current[watchId] : watchFieldsRef.current;
    var combinedDefaultValues = isUndefined(defaultValue) ? defaultValuesRef.current : defaultValue;
    var fieldValues = getFieldsValues(fieldsRef, shallowFieldsStateRef, false, fieldNames);

    if (isString(fieldNames)) {
      return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(defaultValue) ? get(combinedDefaultValues, fieldNames) : defaultValue, true);
    }

    if (Array.isArray(fieldNames)) {
      return fieldNames.reduce(function (previous, name) {
        return Object.assign(Object.assign({}, previous), {
          [name]: assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues)
        });
      }, {});
    }

    isWatchAllRef.current = isUndefined(watchId);
    return transformToNestObject(!isEmptyObject(fieldValues) && fieldValues || combinedDefaultValues);
  }, []);

  function watch(fieldNames, defaultValue) {
    return watchInternal(fieldNames, defaultValue);
  }

  function unregister(name) {
    var _iterator8 = _createForOfIteratorHelper(Array.isArray(name) ? name : [name]),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var fieldName = _step8.value;
        removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }

  function registerFieldRef(ref) {
    var validateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (process.env.NODE_ENV !== 'production') {
      if (!ref.name) {
        return console.warn('📋 Field is missing `name` attribute', ref, "https://react-hook-form.com/api#useForm");
      }

      if (fieldArrayNamesRef.current.has(ref.name.split(/\[\d+\]$/)[0]) && !RegExp("^".concat(ref.name.split(/\[\d+\]$/)[0], "[\\d+].\\w+").replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(ref.name)) {
        return console.warn('📋 `name` prop should be in object shape: name="test[index].name"', ref, 'https://react-hook-form.com/api#useFieldArray');
      }
    }

    var name = ref.name,
        type = ref.type,
        value = ref.value;
    var fieldRefAndValidationOptions = Object.assign({
      ref
    }, validateOptions);
    var fields = fieldsRef.current;
    var isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
    var isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);

    var compareRef = function compareRef(currentRef) {
      return isWeb && (!isHTMLElement(ref) || currentRef === ref);
    };

    var field = fields[name];
    var isEmptyDefaultValue = true;
    var defaultValue;

    if (field && (isRadioOrCheckbox ? Array.isArray(field.options) && compact(field.options).find(function (option) {
      return value === option.ref.value && compareRef(option.ref);
    }) : compareRef(field.ref))) {
      fields[name] = Object.assign(Object.assign({}, field), validateOptions);
      return;
    }

    if (type) {
      field = isRadioOrCheckbox ? Object.assign({
        options: [].concat(_toConsumableArray(compact(field && field.options || [])), [{
          ref
        }]),
        ref: {
          type,
          name
        }
      }, validateOptions) : Object.assign({}, fieldRefAndValidationOptions);
    } else {
      field = fieldRefAndValidationOptions;
    }

    fields[name] = field;
    var isEmptyUnmountFields = isUndefined(get(shallowFieldsStateRef.current, name));

    if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
      defaultValue = get(isEmptyUnmountFields ? defaultValuesRef.current : shallowFieldsStateRef.current, name);
      isEmptyDefaultValue = isUndefined(defaultValue);

      if (!isEmptyDefaultValue && !isFieldArray) {
        setFieldValue(name, defaultValue);
      }
    }

    if (!isEmptyObject(validateOptions)) {
      set(fieldsWithValidationRef.current, name, true);

      if (!isOnSubmit && readFormStateRef.current.isValid) {
        validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then(function (error) {
          var previousFormIsValid = formStateRef.current.isValid;
          isEmptyObject(error) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);

          if (previousFormIsValid !== isEmptyObject(error)) {
            updateFormState();
          }
        });
      }
    }

    if (!defaultValuesAtRenderRef.current[name] && !(isFieldArray && isEmptyDefaultValue)) {
      var fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
      set(defaultValuesAtRenderRef.current, name, isEmptyDefaultValue ? isObject(fieldValue) ? Object.assign({}, fieldValue) : fieldValue : defaultValue);
      !isFieldArray && unset(formStateRef.current.dirtyFields, name);
    }

    if (type) {
      attachEventListeners(isRadioOrCheckbox && field.options ? field.options[field.options.length - 1] : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
    }
  }

  function register(refOrValidationOptions, rules) {
    if (!isWindowUndefined) {
      if (isString(refOrValidationOptions)) {
        registerFieldRef({
          name: refOrValidationOptions
        }, rules);
      } else if (isObject(refOrValidationOptions) && 'name' in refOrValidationOptions) {
        registerFieldRef(refOrValidationOptions, rules);
      } else {
        return function (ref) {
          return ref && registerFieldRef(ref, refOrValidationOptions);
        };
      }
    }
  }

  var handleSubmit = useCallback(function (onValid, onInvalid) {
    return /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
        var fieldErrors, fieldValues, _yield$resolverRef$cu4, errors, values, _i4, _Object$values2, field, _name2, fieldError;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (e && e.preventDefault) {
                  e.preventDefault();
                  e.persist();
                }

                fieldErrors = {};
                fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, shallowFieldsStateRef, true));
                readFormStateRef.current.isSubmitting && updateFormState({
                  isSubmitting: true
                });
                _context8.prev = 4;

                if (!resolverRef.current) {
                  _context8.next = 15;
                  break;
                }

                _context8.next = 8;
                return resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);

              case 8:
                _yield$resolverRef$cu4 = _context8.sent;
                errors = _yield$resolverRef$cu4.errors;
                values = _yield$resolverRef$cu4.values;
                formStateRef.current.errors = fieldErrors = errors;
                fieldValues = values;
                _context8.next = 27;
                break;

              case 15:
                _i4 = 0, _Object$values2 = Object.values(fieldsRef.current);

              case 16:
                if (!(_i4 < _Object$values2.length)) {
                  _context8.next = 27;
                  break;
                }

                field = _Object$values2[_i4];

                if (!field) {
                  _context8.next = 24;
                  break;
                }

                _name2 = field.ref.name;
                _context8.next = 22;
                return validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);

              case 22:
                fieldError = _context8.sent;

                if (fieldError[_name2]) {
                  set(fieldErrors, _name2, fieldError[_name2]);
                  unset(validFieldsRef.current, _name2);
                } else if (get(fieldsWithValidationRef.current, _name2)) {
                  unset(formStateRef.current.errors, _name2);
                  set(validFieldsRef.current, _name2, true);
                }

              case 24:
                _i4++;
                _context8.next = 16;
                break;

              case 27:
                if (!(isEmptyObject(fieldErrors) && Object.keys(formStateRef.current.errors).every(function (name) {
                  return name in fieldsRef.current;
                }))) {
                  _context8.next = 33;
                  break;
                }

                updateFormState({
                  errors: {},
                  isSubmitting: true
                });
                _context8.next = 31;
                return onValid(fieldValues, e);

              case 31:
                _context8.next = 39;
                break;

              case 33:
                formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                _context8.t0 = onInvalid;

                if (!_context8.t0) {
                  _context8.next = 38;
                  break;
                }

                _context8.next = 38;
                return onInvalid(formStateRef.current.errors, e);

              case 38:
                shouldFocusError && focusOnErrorField(fieldsRef.current, formStateRef.current.errors);

              case 39:
                _context8.prev = 39;
                updateFormState({
                  isSubmitted: true,
                  isSubmitting: false,
                  isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
                  errors: formStateRef.current.errors,
                  submitCount: formStateRef.current.submitCount + 1
                });
                return _context8.finish(39);

              case 42:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[4,, 39, 42]]);
      }));

      return function (_x11) {
        return _ref23.apply(this, arguments);
      };
    }();
  }, [shouldFocusError, isValidateAllFieldCriteria]);

  var resetRefs = function resetRefs(_ref24) {
    var errors = _ref24.errors,
        isDirty = _ref24.isDirty,
        isSubmitted = _ref24.isSubmitted,
        touched = _ref24.touched,
        isValid = _ref24.isValid,
        submitCount = _ref24.submitCount,
        dirtyFields = _ref24.dirtyFields;

    if (!isValid) {
      validFieldsRef.current = {};
      fieldsWithValidationRef.current = {};
    }

    defaultValuesAtRenderRef.current = {};
    fieldArrayDefaultValuesRef.current = {};
    watchFieldsRef.current = new Set();
    isWatchAllRef.current = false;
    updateFormState({
      submitCount: submitCount ? formStateRef.current.submitCount : 0,
      isDirty: isDirty ? formStateRef.current.isDirty : false,
      isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
      isValid: isValid ? formStateRef.current.isValid : false,
      dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
      touched: touched ? formStateRef.current.touched : {},
      errors: errors ? formStateRef.current.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  };

  var reset = function reset(values) {
    var omitResetState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (isWeb) {
      for (var _i5 = 0, _Object$values3 = Object.values(fieldsRef.current); _i5 < _Object$values3.length; _i5++) {
        var field = _Object$values3[_i5];

        if (field) {
          var _ref25 = field.ref,
              options = field.options;
          var inputRef = isRadioOrCheckboxFunction(_ref25) && Array.isArray(options) ? options[0].ref : _ref25;

          if (isHTMLElement(inputRef)) {
            try {
              inputRef.closest('form').reset();
              break;
            } catch (_a) {}
          }
        }
      }
    }

    fieldsRef.current = {};
    defaultValuesRef.current = cloneObject(values || defaultValuesRef.current, isWeb);
    values && renderWatchedInputs('');
    Object.values(resetFieldArrayFunctionRef.current).forEach(function (resetFieldArray) {
      return isFunction(resetFieldArray) && resetFieldArray();
    });
    shallowFieldsStateRef.current = shouldUnregister ? {} : cloneObject(values, isWeb) || {};
    resetRefs(omitResetState);
  };

  useEffect(function () {
    isUnMount.current = false;
    resolver && readFormStateRef.current.isValid && validateResolver();
    observerRef.current = observerRef.current || !isWeb ? observerRef.current : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
    return function () {
      isUnMount.current = true;
      observerRef.current && observerRef.current.disconnect();
      shallowFieldsStateRef.current = {};

      if (process.env.NODE_ENV !== 'production') {
        return;
      }

      Object.values(fieldsRef.current).forEach(function (field) {
        return removeFieldEventListenerAndRef(field, true);
      });
    };
  }, [removeFieldEventListenerAndRef]);

  if (!resolver && readFormStateRef.current.isValid) {
    formState.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
  }

  var commonProps = {
    trigger,
    setValue: useCallback(setValue, [setInternalValue, trigger]),
    getValues: useCallback(getValues, []),
    register: useCallback(register, [defaultValuesRef.current]),
    unregister: useCallback(unregister, [])
  };
  var control = Object.assign({
    updateWatchedValue,
    shouldUnregister,
    removeFieldEventListener,
    watchInternal,
    mode: modeRef.current,
    reValidateMode: {
      isReValidateOnBlur,
      isReValidateOnChange
    },
    fieldsRef,
    resetFieldArrayFunctionRef,
    useWatchFieldsRef,
    useWatchRenderFunctionsRef,
    fieldArrayDefaultValuesRef,
    validFieldsRef,
    fieldsWithValidationRef,
    fieldArrayNamesRef,
    readFormStateRef,
    formStateRef,
    defaultValuesRef,
    shallowFieldsStateRef,
    updateFormState,
    validateResolver: resolver ? validateResolver : undefined
  }, commonProps);
  return Object.assign({
    watch,
    control,
    formState: isProxyEnabled ? new Proxy(formState, {
      get: function get(obj, prop) {
        if (process.env.NODE_ENV !== 'production') {
          if (prop === 'isValid' && isOnSubmit) {
            console.warn('📋 `formState.isValid` is applicable with `onTouched`, `onChange` or `onBlur` mode. https://react-hook-form.com/api#formState');
          }
        }

        if (prop in obj) {
          readFormStateRef.current[prop] = true;
          return obj[prop];
        }

        return undefined;
      }
    }) : formState,
    handleSubmit,
    reset: useCallback(reset, []),
    clearErrors: useCallback(clearErrors, []),
    setError: useCallback(setError, []),
    errors: formState.errors
  }, commonProps);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var FormContext = createContext(null);
FormContext.displayName = 'RHFContext';

var useFormContext = function useFormContext() {
  return useContext(FormContext);
};

var FormProvider = function FormProvider(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return createElement(FormContext.Provider, {
    value: Object.assign({}, props)
  }, children);
};

var generateId = function generateId() {
  var d = typeof performance === UNDEFINED ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

var removeAt = function removeAt(data, index) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(data.slice(index + 1)));
};

function removeAtIndexes(data, index) {
  var k = -1;

  while (++k < data.length) {
    if (index.indexOf(k) >= 0) {
      delete data[k];
    }
  }

  return compact(data);
}

var removeArrayAt = function removeArrayAt(data, index) {
  return isUndefined(index) ? [] : Array.isArray(index) ? removeAtIndexes(data, index) : removeAt(data, index);
};

var moveArrayAt = function moveArrayAt(data, from, to) {
  if (Array.isArray(data)) {
    if (isUndefined(data[to])) {
      data[to] = undefined;
    }

    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
  }

  return [];
};

var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
  var temp = [data[indexB], data[indexA]];
  data[indexA] = temp[0];
  data[indexB] = temp[1];
};

function prepend(data, value) {
  return [].concat(_toConsumableArray(Array.isArray(value) ? value : [value || undefined]), _toConsumableArray(data));
}

function insert(data, index, value) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(Array.isArray(value) ? value : [value || undefined]), _toConsumableArray(data.slice(index)));
}

var fillEmptyArray = function fillEmptyArray(value) {
  return Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;
};

function mapValueToBoolean(value) {
  if (isObject(value)) {
    var object = {};

    for (var key in value) {
      object[key] = true;
    }

    return [object];
  }

  return [true];
}

var fillBooleanArray = function fillBooleanArray(value) {
  return (Array.isArray(value) ? value : [value]).map(mapValueToBoolean).flat();
};

var mapIds = function mapIds(values, keyName) {
  return values.map(function (value) {
    return Object.assign({
      [keyName]: generateId()
    }, value);
  });
};

var useFieldArray = function useFieldArray(_ref26) {
  var control = _ref26.control,
      name = _ref26.name,
      _ref26$keyName = _ref26.keyName,
      keyName = _ref26$keyName === void 0 ? 'id' : _ref26$keyName;
  var methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 useFieldArray is missing `control` prop. https://react-hook-form.com/api#useFieldArray');
    }
  }

  var focusIndexRef = useRef(-1);

  var _ref27 = control || methods.control,
      updateWatchedValue = _ref27.updateWatchedValue,
      resetFieldArrayFunctionRef = _ref27.resetFieldArrayFunctionRef,
      fieldArrayNamesRef = _ref27.fieldArrayNamesRef,
      fieldsRef = _ref27.fieldsRef,
      defaultValuesRef = _ref27.defaultValuesRef,
      removeFieldEventListener = _ref27.removeFieldEventListener,
      formStateRef = _ref27.formStateRef,
      shallowFieldsStateRef = _ref27.shallowFieldsStateRef,
      updateFormState = _ref27.updateFormState,
      readFormStateRef = _ref27.readFormStateRef,
      validFieldsRef = _ref27.validFieldsRef,
      fieldsWithValidationRef = _ref27.fieldsWithValidationRef,
      fieldArrayDefaultValuesRef = _ref27.fieldArrayDefaultValuesRef,
      validateResolver = _ref27.validateResolver,
      getValues = _ref27.getValues,
      shouldUnregister = _ref27.shouldUnregister;

  var fieldArrayParentName = getFieldArrayParentName(name);
  var memoizedDefaultValues = useRef(_toConsumableArray(get(fieldArrayDefaultValuesRef.current, fieldArrayParentName) ? get(fieldArrayDefaultValuesRef.current, name, []) : get(shouldUnregister ? defaultValuesRef.current : shallowFieldsStateRef.current, name, [])));

  var _useState3 = useState(mapIds(memoizedDefaultValues.current, keyName)),
      _useState4 = _slicedToArray(_useState3, 2),
      fields = _useState4[0],
      setFields = _useState4[1];

  var allFields = useRef(fields);

  var getCurrentFieldsValues = function getCurrentFieldsValues() {
    return get(getValues(), name, allFields.current).map(function (item, index) {
      return Object.assign(Object.assign({}, allFields.current[index]), item);
    });
  };

  allFields.current = fields;
  fieldArrayNamesRef.current.add(name);

  if (!get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) {
    set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, get(defaultValuesRef.current, fieldArrayParentName));
  }

  var setFieldAndValidState = function setFieldAndValidState(fieldsValues) {
    setFields(fieldsValues);

    if (readFormStateRef.current.isValid && validateResolver) {
      var values = getValues();
      set(values, name, fieldsValues);
      validateResolver(values);
    }
  };

  var getIsDirtyState = function getIsDirtyState(flagOrFields) {
    return (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && (isUndefined(flagOrFields) || !deepEqual(flagOrFields.map(function () {
      var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _b = keyName,
          omitted = _a[_b],
          rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);

      return rest;
    }), get(defaultValuesRef.current, name)));
  };

  var resetFields = function resetFields() {
    for (var key in fieldsRef.current) {
      isMatchFieldArrayName(key, name) && removeFieldEventListener(fieldsRef.current[key], true);
    }
  };

  var cleanup = function cleanup(ref) {
    return !compact(get(ref, name, [])).length && unset(ref, name);
  };

  var updateDirtyFieldsWithDefaultValues = function updateDirtyFieldsWithDefaultValues(updatedFieldArrayValues) {
    var defaultFieldArrayValues = get(defaultValuesRef.current, name, []);

    var updateDirtyFieldsBaseOnDefaultValues = function updateDirtyFieldsBaseOnDefaultValues(base, target) {
      for (var key in base) {
        for (var innerKey in base[key]) {
          if (innerKey !== keyName && (!target[key] || !base[key] || base[key][innerKey] !== target[key][innerKey])) {
            set(formStateRef.current.dirtyFields, "".concat(name, "[").concat(key, "]"), Object.assign(Object.assign({}, get(formStateRef.current.dirtyFields, "".concat(name, "[").concat(key, "]"), {})), {
              [innerKey]: true
            }));
          }
        }
      }
    };

    if (updatedFieldArrayValues) {
      updateDirtyFieldsBaseOnDefaultValues(defaultFieldArrayValues, updatedFieldArrayValues);
      updateDirtyFieldsBaseOnDefaultValues(updatedFieldArrayValues, defaultFieldArrayValues);
    }
  };

  var batchStateUpdate = function batchStateUpdate(method, args, updatedFieldValues) {
    var isDirty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var shouldSet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldUpdateValid = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (get(shallowFieldsStateRef.current, name)) {
      var output = method(get(shallowFieldsStateRef.current, name), args.argA, args.argB);
      shouldSet && set(shallowFieldsStateRef.current, name, output);
    }

    if (get(fieldArrayDefaultValuesRef.current, name)) {
      var _output = method(get(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);

      shouldSet && set(fieldArrayDefaultValuesRef.current, name, _output);
      cleanup(fieldArrayDefaultValuesRef.current);
    }

    if (Array.isArray(get(formStateRef.current.errors, name))) {
      var _output2 = method(get(formStateRef.current.errors, name), args.argA, args.argB);

      shouldSet && set(formStateRef.current.errors, name, _output2);
      cleanup(formStateRef.current.errors);
    }

    if (readFormStateRef.current.touched && get(formStateRef.current.touched, name)) {
      var _output3 = method(get(formStateRef.current.touched, name), args.argA, args.argB);

      shouldSet && set(formStateRef.current.touched, name, _output3);
      cleanup(formStateRef.current.touched);
    }

    if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
      var _output4 = method(get(formStateRef.current.dirtyFields, name, []), args.argC, args.argD);

      shouldSet && set(formStateRef.current.dirtyFields, name, _output4);
      updateDirtyFieldsWithDefaultValues(updatedFieldValues);
      cleanup(formStateRef.current.dirtyFields);
    }

    if (shouldUpdateValid && readFormStateRef.current.isValid && !validateResolver) {
      set(validFieldsRef.current, name, method(get(validFieldsRef.current, name, []), args.argA));
      cleanup(validFieldsRef.current);
      set(fieldsWithValidationRef.current, name, method(get(fieldsWithValidationRef.current, name, []), args.argA));
      cleanup(fieldsWithValidationRef.current);
    }

    updateFormState({
      errors: formStateRef.current.errors,
      dirtyFields: formStateRef.current.dirtyFields,
      isDirty,
      touched: formStateRef.current.touched
    });
  };

  var append = function append(value) {
    var shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var updateFormValues = [].concat(_toConsumableArray(allFields.current), _toConsumableArray(mapIds(Array.isArray(value) ? value : [value], keyName)));
    setFieldAndValidState(updateFormValues);

    if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
      updateDirtyFieldsWithDefaultValues(updateFormValues);
      updateFormState({
        isDirty: true,
        dirtyFields: formStateRef.current.dirtyFields
      });
    }

    if (!shouldUnregister) {
      shallowFieldsStateRef.current[name] = [].concat(_toConsumableArray(shallowFieldsStateRef.current[name] || []), [value]);
    }

    focusIndexRef.current = shouldFocus ? allFields.current.length : -1;
  };

  var prepend$1 = function prepend$1(value) {
    var shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var emptyArray = fillEmptyArray(value);
    var updatedFieldArrayValues = prepend(getCurrentFieldsValues(), mapIds(Array.isArray(value) ? value : [value], keyName));
    setFieldAndValidState(updatedFieldArrayValues);
    resetFields();
    batchStateUpdate(prepend, {
      argA: emptyArray,
      argC: fillBooleanArray(value)
    }, updatedFieldArrayValues);
    focusIndexRef.current = shouldFocus ? 0 : -1;
  };

  var remove = function remove(index) {
    var fieldValues = getCurrentFieldsValues();
    var updatedFieldValues = removeArrayAt(fieldValues, index);
    setFieldAndValidState(updatedFieldValues);
    resetFields();
    batchStateUpdate(removeArrayAt, {
      argA: index,
      argC: index
    }, updatedFieldValues, getIsDirtyState(removeArrayAt(fieldValues, index)), true, true);
  };

  var insert$1 = function insert$1(index, value) {
    var shouldFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var emptyArray = fillEmptyArray(value);
    var fieldValues = getCurrentFieldsValues();
    var updatedFieldArrayValues = insert(fieldValues, index, mapIds(Array.isArray(value) ? value : [value], keyName));
    setFieldAndValidState(updatedFieldArrayValues);
    resetFields();
    batchStateUpdate(insert, {
      argA: index,
      argB: emptyArray,
      argC: index,
      argD: fillBooleanArray(value)
    }, updatedFieldArrayValues, getIsDirtyState(insert(fieldValues, index)));
    focusIndexRef.current = shouldFocus ? index : -1;
  };

  var swap = function swap(indexA, indexB) {
    var fieldValues = getCurrentFieldsValues();
    swapArrayAt(fieldValues, indexA, indexB);
    resetFields();
    setFieldAndValidState(_toConsumableArray(fieldValues));
    batchStateUpdate(swapArrayAt, {
      argA: indexA,
      argB: indexB,
      argC: indexA,
      argD: indexB
    }, undefined, getIsDirtyState(fieldValues), false);
  };

  var move = function move(from, to) {
    var fieldValues = getCurrentFieldsValues();
    moveArrayAt(fieldValues, from, to);
    resetFields();
    setFieldAndValidState(_toConsumableArray(fieldValues));
    batchStateUpdate(moveArrayAt, {
      argA: from,
      argB: to,
      argC: from,
      argD: to
    }, undefined, getIsDirtyState(fieldValues), false);
  };

  var reset = function reset(data) {
    resetFields();
    !data && unset(fieldArrayDefaultValuesRef.current, name);
    unset(shallowFieldsStateRef.current, name);
    memoizedDefaultValues.current = get(data || defaultValuesRef.current, name);
    setFields(mapIds(memoizedDefaultValues.current, keyName));
  };

  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        console.warn('📋 useFieldArray is missing `name` attribute. https://react-hook-form.com/api#useFieldArray');
      }
    }

    var defaultValues = get(fieldArrayDefaultValuesRef.current, name);

    if (defaultValues && fields.length < defaultValues.length) {
      defaultValues.pop();
      set(fieldArrayDefaultValuesRef.current, name, defaultValues);
    }

    updateWatchedValue(name);

    if (focusIndexRef.current > -1) {
      for (var key in fieldsRef.current) {
        var field = fieldsRef.current[key];

        if (key.startsWith("".concat(name, "[").concat(focusIndexRef.current, "]")) && field.ref.focus) {
          field.ref.focus();
          break;
        }
      }
    }

    focusIndexRef.current = -1;
  }, [fields, name]);
  useEffect(function () {
    var resetFunctions = resetFieldArrayFunctionRef.current;
    var fieldArrayNames = fieldArrayNamesRef.current;

    if (!getFieldArrayParentName(name)) {
      resetFunctions[name] = reset;
    }

    return function () {
      resetFields();
      delete resetFunctions[name];
      fieldArrayNames.delete(name);
    };
  }, []);
  return {
    swap: useCallback(swap, [name]),
    move: useCallback(move, [name]),
    prepend: useCallback(prepend$1, [name]),
    append: useCallback(append, [name]),
    remove: useCallback(remove, [name]),
    insert: useCallback(insert$1, [name]),
    fields
  };
};

function useWatch(_ref28) {
  var control = _ref28.control,
      name = _ref28.name,
      defaultValue = _ref28.defaultValue;
  var methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 useWatch is missing `control` prop. https://react-hook-form.com/api#useWatch');
    }
  }

  var _ref29 = control || methods.control,
      useWatchFieldsRef = _ref29.useWatchFieldsRef,
      useWatchRenderFunctionsRef = _ref29.useWatchRenderFunctionsRef,
      watchInternal = _ref29.watchInternal,
      defaultValuesRef = _ref29.defaultValuesRef;

  var _useState5 = useState(isUndefined(defaultValue) ? isString(name) ? get(defaultValuesRef.current, name) : Array.isArray(name) ? name.reduce(function (previous, inputName) {
    return Object.assign(Object.assign({}, previous), {
      [inputName]: get(defaultValuesRef.current, inputName)
    });
  }, {}) : defaultValuesRef.current : defaultValue),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var idRef = useRef();
  var defaultValueRef = useRef(defaultValue);
  var updateWatchValue = useCallback(function () {
    var value = watchInternal(name, defaultValueRef.current, idRef.current);
    setValue(isObject(value) ? Object.assign({}, value) : Array.isArray(value) ? _toConsumableArray(value) : value);
  }, [setValue, watchInternal, defaultValueRef, name, idRef]);
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (name === '') {
        console.warn('📋 useWatch is missing `name` attribute. https://react-hook-form.com/api#useWatch');
      }
    }

    var id = idRef.current = generateId();
    var watchFieldsHookRender = useWatchRenderFunctionsRef.current;
    var watchFieldsHook = useWatchFieldsRef.current;
    watchFieldsHook[id] = new Set();
    watchFieldsHookRender[id] = updateWatchValue;
    watchInternal(name, defaultValueRef.current, id);
    return function () {
      delete watchFieldsHook[id];
      delete watchFieldsHookRender[id];
    };
  }, [name, updateWatchValue, useWatchRenderFunctionsRef, useWatchFieldsRef, watchInternal, defaultValueRef]);
  return isUndefined(value) ? defaultValue : value;
}

var getInputValue = function getInputValue(event) {
  return isPrimitive(event) || !isObject(event.target) || isObject(event.target) && !event.type ? event : isUndefined(event.target.value) ? event.target.checked : event.target.value;
};

var Controller = function Controller(_a) {
  var name = _a.name,
      rules = _a.rules,
      as = _a.as,
      render = _a.render,
      defaultValue = _a.defaultValue,
      control = _a.control,
      onFocus = _a.onFocus,
      rest = __rest(_a, ["name", "rules", "as", "render", "defaultValue", "control", "onFocus"]);

  var methods = useFormContext();

  if (process.env.NODE_ENV !== 'production') {
    if (!control && !methods) {
      throw new Error('📋 Controller is missing `control` prop. https://react-hook-form.com/api#Controller');
    }
  }

  var _ref30 = control || methods.control,
      defaultValuesRef = _ref30.defaultValuesRef,
      setValue = _ref30.setValue,
      register = _ref30.register,
      unregister = _ref30.unregister,
      trigger = _ref30.trigger,
      mode = _ref30.mode,
      _ref30$reValidateMode = _ref30.reValidateMode,
      isReValidateOnBlur = _ref30$reValidateMode.isReValidateOnBlur,
      isReValidateOnChange = _ref30$reValidateMode.isReValidateOnChange,
      _ref30$formStateRef$c = _ref30.formStateRef.current,
      isSubmitted = _ref30$formStateRef$c.isSubmitted,
      touched = _ref30$formStateRef$c.touched,
      updateFormState = _ref30.updateFormState,
      readFormStateRef = _ref30.readFormStateRef,
      fieldsRef = _ref30.fieldsRef,
      fieldArrayNamesRef = _ref30.fieldArrayNamesRef,
      shallowFieldsStateRef = _ref30.shallowFieldsStateRef;

  var isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);

  var getInitialValue = function getInitialValue() {
    return !isUndefined(get(shallowFieldsStateRef.current, name)) && isNotFieldArray ? get(shallowFieldsStateRef.current, name) : isUndefined(defaultValue) ? get(defaultValuesRef.current, name) : defaultValue;
  };

  var _useState7 = useState(getInitialValue()),
      _useState8 = _slicedToArray(_useState7, 2),
      value = _useState8[0],
      setInputStateValue = _useState8[1];

  var valueRef = useRef(value);
  var onFocusRef = useRef(onFocus);

  var shouldValidate = function shouldValidate(isBlurEvent) {
    return !skipValidation(Object.assign({
      isBlurEvent,
      isReValidateOnBlur,
      isReValidateOnChange,
      isSubmitted,
      isTouched: !!get(touched, name)
    }, mode));
  };

  var commonTask = function commonTask(_ref31) {
    var _ref32 = _slicedToArray(_ref31, 1),
        event = _ref32[0];

    var data = getInputValue(event);
    setInputStateValue(data);
    valueRef.current = data;
    return data;
  };

  var registerField = useCallback(function () {
    if (process.env.NODE_ENV !== 'production' && !name) {
      return console.warn('📋 Field is missing `name` prop. https://react-hook-form.com/api#Controller');
    }

    if (fieldsRef.current[name]) {
      fieldsRef.current[name] = Object.assign({
        ref: fieldsRef.current[name].ref
      }, rules);
    } else {
      register(Object.defineProperty({
        name,
        focus: onFocusRef.current
      }, VALUE, {
        set(data) {
          setInputStateValue(data);
          valueRef.current = data;
        },

        get() {
          return valueRef.current;
        }

      }), rules);

      if (isNotFieldArray && !get(defaultValuesRef.current, name)) {
        setInputStateValue(getInitialValue());
      }
    }
  }, [rules, name, register]);
  useEffect(function () {
    return function () {
      return unregister(name);
    };
  }, [unregister, name]);
  useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      if (isUndefined(value)) {
        console.warn("\uD83D\uDCCB ".concat(name, " is missing in the 'defaultValue' prop of either its Controller (https://react-hook-form.com/api#Controller) or useForm (https://react-hook-form.com/api#useForm)"));
      }

      if (!as && !render || as && render) {
        console.warn("\uD83D\uDCCB ".concat(name, " Controller should use either the 'as' or 'render' prop, not both. https://react-hook-form.com/api#Controller"));
      }

      if (!isNotFieldArray && isUndefined(defaultValue)) {
        console.warn('📋 Controller is missing `defaultValue` prop when using `useFieldArray`. https://react-hook-form.com/api#Controller');
      }
    }

    registerField();
  }, [registerField]);
  useEffect(function () {
    if (!fieldsRef.current[name]) {
      registerField();

      if (isNotFieldArray) {
        setInputStateValue(getInitialValue());
      }
    }
  });

  var onBlur = function onBlur() {
    if (readFormStateRef.current.touched && !get(touched, name)) {
      set(touched, name, true);
      updateFormState({
        touched
      });
    }

    if (shouldValidate(true)) {
      trigger(name);
    }
  };

  var onChange = function onChange() {
    for (var _len = arguments.length, event = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      event[_key2] = arguments[_key2];
    }

    return setValue(name, commonTask(event), {
      shouldValidate: shouldValidate(),
      shouldDirty: true
    });
  };

  var props = Object.assign(Object.assign({}, rest), {
    onChange,
    onBlur,
    name,
    value
  });
  return as ? isValidElement(as) ? cloneElement(as, props) : createElement(as, props) : render ? render({
    onChange,
    onBlur,
    value,
    name
  }) : null;
};

export { Controller, FormProvider, appendErrors, get, transformToNestObject, useFieldArray, useForm, useFormContext, useWatch };